import React from 'react'
import { Routes, Route } from 'react-router-dom'
import type { Location } from 'react-router-dom'
import Home from '../pages/Home'
import Impressum from '../pages/Impressum'
import Datenschutz from '../pages/Datenschutz'
import Contact from '../pages/Contact'
import NewPostPage from '../pages/NewPostPage'
import PostsList from '../pages/PostsList'
import Videos from '../pages/Videos'
import VideoDetail from '../pages/VideoDetail'
import SubmitVideo from '../pages/SubmitVideo'
import AdminSuggestions from '../pages/AdminSuggestions'
import VideoSeriesManagement from '../pages/VideoSeriesManagement'
import NotFound from '../pages/NotFound'
import RequireAuth from './RequireAuth'
import Login from '../pages/Login'
import OAuthCallback from '../pages/OAuthCallback'

type AppRoutesProps = {
  location: Location
}

const AppRoutes: React.FC<AppRoutesProps> = ({ location }) => (
  <Routes location={location}>
    <Route path="/" element={<Home />} />
    <Route path="/impressum" element={<Impressum />} />
    <Route path="/datenschutz" element={<Datenschutz />} />
    <Route path="/kontakt" element={<Contact />} />
    <Route path="/neuer-beitrag" element={<RequireAuth><NewPostPage /></RequireAuth>} />
    <Route path="/beitraege" element={<PostsList />} />
    <Route path="/videos" element={<Videos />} />
    <Route path="/video/:id" element={<VideoDetail />} />
    <Route path="/submit" element={<RequireAuth><SubmitVideo /></RequireAuth>} />
    <Route path="/login" element={<Login />} />
    <Route path="/oauth/callback" element={<OAuthCallback />} />
    <Route path="/admin/suggestions" element={<RequireAuth><AdminSuggestions /></RequireAuth>} />
    <Route path="/admin/series" element={<RequireAuth><VideoSeriesManagement /></RequireAuth>} />
    <Route path="*" element={<NotFound />} />
  </Routes>
)

export default AppRoutes

